export const STRING_DESKTOP_TITLE = 'Connect Face-to-Face With Employers. Instantly.';
export const STRING_MOBILE_TITLE = 'Connect face-to-face with employers. Instantly.';

export const STRING_NOTIFICATION_PROMO_DESKTOP_DESCRIPTION = 'You can get invited to real-time video calls. Get the app and turn on notifications so you don\'t miss an invite.';
export const STRING_NOTIFICATION_PROMO_QR_CODE_DESCRIPTION = 'Scan to get the app';

export const STRING_PRODUCT_PROMO_DESKTOP_DESCRIPTION = 'You can get invited to real-time video calls. Get the app for the best video call experience.';
export const STRING_PRODUCT_PROMO_QR_CODE_DESCRIPTION = 'Scan to get the app';

export const STRING_NOTIFICATION_PROMO_MOBILE_DESCRIPTION = 'You can get invited to real-time video calls. Get the app and turn on notifications so you don\'t miss an invite.';
export const STRING_PRODUCT_PROMO_MOBILE_DESCRIPTION = 'You can get invited to real-time video calls. Get the app for the best video call experience.';

export const STRING_PROMO_BUTTON = 'Done';
export const STRING_PROMO_BUTTON_MOBILE = 'Get the App';

export const STRING_PRODUCT_DOWNLOAD_URL = 'https://ziprecruiter.onelink.me/K26Y/jqr962w9';
export const STRING_NOTIFICATION_DOWNLOAD_URL = 'https://ziprecruiter.onelink.me/K26Y/lscad1vu';

export const STRING_PRODUCT_QR_CODE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/ii_mobile_app_promo/desktop_qrcode_product_promo.png';
export const STRING_NOTIFICATION_QR_CODE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/ii_mobile_app_promo/desktop_qrcode_notification_promo.png';

export const STRING_DESKTOP_PRODUCT_IMAGE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/onboarding/instant-interview-promo.png';
export const STRING_DESKTOP_NOTIFICATION_IMAGE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/ii_mobile_app_promo/desktop_ii_notification_promo.png';

export const STRING_MOBILE_PRODUCT_IMAGE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/onboarding/instant-interview-promo.png';
export const STRING_MOBILE_NOTIFICATION_IMAGE_FILEPATH = 'https://www.ziprecruiter.com/assets/static/img/ii_mobile_app_promo/mobile_ii_notification_promo.png';
